import React from "react";
import { XStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";

import { CheckboxFormControl } from "../Web/CheckboxFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: CheckboxFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let checkbox = new CheckboxFormControl();
    container.add(checkbox);

    return { form: ui, control: checkbox };
}

export const CheckBoxStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Default Control";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Checkbox",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Default As true";
            ui.control.defaultValue = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Checkbox",
        "Default To True",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "From Data";
            ui.control.valueName = "checkbox";

            let data = new ExecutionData();
            data.values[ui.control.valueName] = true;

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Checkbox",
        "From Data",
    ),
];
